<template>
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 7.5L4 10.5C5.5 7.66667 9.1 1.8 11.5 1" stroke="currentColor" stroke-width="2" />
  </svg>
</template>
